import { useEffect } from 'react';

const MemoriiWorksService = () => {

   useEffect(() => {
    const timer = setTimeout(() => {
      window.location.href = "https://memorii-works.com";
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div style={{ textAlign: "center", padding: "80px 20px" }}>
      <h1>サイト移行のお知らせ</h1>

      <p>
        このたび、サービスサイトのドメインを変更いたしました。
        <br />
        お手数ですが、今後は下記の新しいURLよりアクセスをお願いいたします。
      </p>

      <p style={{ marginTop: 40 }}>
        <a
          href="https://memorii-works.com"
          style={{ fontSize: 20, color: "#0070f3" }}
        >
          https://memorii-works.com
        </a>
      </p>

      <p style={{ marginTop: 40 }}>
        5秒後に自動で新しいサイトへ移動します。
      </p>
    </div>
  );

  return (
    <>
    </>
  );
}

export default MemoriiWorksService;
